import { Injectable } from '@angular/core';
import { IProfileSLA, IProfileSLADefinition, IProfileSLAResponse } from './bp-profiles-sla-data.service';
import { Dictionary } from '../../../../../type_definitions/vendor';
import * as _ from 'underscore';
import { FormattingService } from '../../../../shared/services/formatting.service';
import { util } from '../../../../shared/util';

@Injectable()
export class BPProfilesSLAService {

  constructor(
    private formattingService:FormattingService
  ) {
    /**/
  }

  public processSLA(data:IProfileSLAResponse):Dictionary<IProfileSLA> {
    if (!data) {
      return;
    }

    const profileSLA:Dictionary<IProfileSLA> = {
      // set partner sla
      'BPPROFILES.SLA.BUSINESS_PARTNER': {
        companyCountry: data.profileSla.companyCountry,
        slaDefinitions: _.map(data.profileSla.slaDefinitions, this.setInitialDefinitionValue)
      }
    };

    // set distributor sla
    _.each(data.distributorsSlas, (distributorSLA:IProfileSLA) => {
      profileSLA[this.formattingService.formatCompanyCountry(distributorSLA.companyCountry)] = {
        companyCountry: distributorSLA.companyCountry,
        slaDefinitions: _.map(distributorSLA.slaDefinitions, this.setInitialDefinitionValue)
      };
    });

    return profileSLA;
  }

  public createSLARequestData(profileSLA:Dictionary<IProfileSLA>, backupSLAResponse:IProfileSLAResponse):IProfileSLA[] {
    const modelSLAs:IProfileSLA[] = this.flattenModelSLA(profileSLA);
    const backupSLAs:IProfileSLA[] = this.flattenBackupSLA(backupSLAResponse);
    const requestDataValues:IProfileSLA[] = [];

    if (backupSLAs?.length) {
      _.each(backupSLAs, (backupSLA:IProfileSLA) => {
        // define current SLA on every iteration
        const currentSLA:IProfileSLA = {
          companyCountry: backupSLA.companyCountry,
          slaDefinitions: []
        };

        // try to find model SLA based on company country id
        const modelSLA:IProfileSLA = _.find(modelSLAs, (modelSLA:IProfileSLA) => modelSLA.companyCountry.id === backupSLA.companyCountry.id);

        if (modelSLA) {
          // loop on sla definitions and try to see difference between both SLA definition
          // we only interested sending object to server which definition is updated
          _.each(backupSLA.slaDefinitions, (originalSLADefinition:IProfileSLADefinition) => {
            const modelSLADefinition:IProfileSLADefinition = _.findWhere(modelSLA?.slaDefinitions, { id: originalSLADefinition.id });

            if (modelSLADefinition) {
              // remove not used object necessary for server
              delete modelSLADefinition.showInfo;
            }

            if (this.isDifferent(originalSLADefinition, modelSLADefinition)) {
              currentSLA.slaDefinitions.push(modelSLADefinition);
            }
          });
        }

        // if variable 'currentSLA' sla definitions is not empty then add current SLA to 'requestDataValues'
        if (!_.isEmpty(currentSLA.slaDefinitions)) {
          requestDataValues.push(currentSLA);
        }
      });
    } else {
      // safeguard: if backup sla somehow is empty then just add model sla as it is
      return modelSLAs;
    }

    return requestDataValues;
  }

  private setInitialDefinitionValue(slaDefinition:IProfileSLADefinition):IProfileSLADefinition {
    return {
      ...slaDefinition,
      slaValue: util.notNullOrUndefinedOrEmpty(slaDefinition.slaValue) ? slaDefinition.slaValue : {},
      showInfo: false
    };
  }

  private isDifferent(sla1:IProfileSLADefinition, sla2:IProfileSLADefinition) {
    return !_.isEqual(sla1?.slaValue?.days, sla2?.slaValue?.days) || !_.isEqual(sla1?.slaValue?.comments, sla2?.slaValue?.comments);
  }

  private flattenModelSLA(profileSLA:Dictionary<IProfileSLA>):IProfileSLA[] {
    if (!profileSLA) {
      return [];
    }

    const modelSLA:IProfileSLA[] = [];
    _.each(profileSLA, (sla:IProfileSLA) => {
      modelSLA.push(sla);
    });
    return modelSLA;
  }

  private flattenBackupSLA(backupSLA:IProfileSLAResponse):IProfileSLA[] {
    if (!backupSLA) {
      return [];
    }
    return [backupSLA.profileSla].concat(_.map(backupSLA.distributorsSlas, (distributorSLA:IProfileSLA) => distributorSLA));
  }
}